// extracted by mini-css-extract-plugin
export var betaBadge = "style-module--betaBadge--d1a64";
export var companyLinks = "style-module--companyLinks--ecd7f";
export var footerCompanyDetails = "style-module--footerCompanyDetails--f3044";
export var footerContainer = "style-module--footerContainer--5c679";
export var footerContent = "style-module--footerContent--a80ec";
export var footerLinks = "style-module--footerLinks--13600";
export var legalText = "style-module--legalText--0f7a2";
export var linkContainer = "style-module--linkContainer--846f1";
export var logoContainer = "style-module--logoContainer--b5224";
export var release = "style-module--release--84fca";
export var releasePopoverHash = "style-module--releasePopoverHash--4ea3b";
export var releaseTooltip = "style-module--releaseTooltip--53962";
export var releaseTrigger = "style-module--releaseTrigger--02834";
export var sitterLink = "style-module--sitterLink--0ed43";
export var trademark = "style-module--trademark--503fc";